import { render, staticRenderFns } from "./BlobSelectionControls.vue?vue&type=template&id=2e7af10a&scoped=true"
import script from "./BlobSelectionControls.vue?vue&type=script&lang=js"
export * from "./BlobSelectionControls.vue?vue&type=script&lang=js"
import style0 from "./BlobSelectionControls.vue?vue&type=style&index=0&id=2e7af10a&prod&scoped=true&lang=css"
import style1 from "./BlobSelectionControls.vue?vue&type=style&index=1&id=2e7af10a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7af10a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VBtn,VIcon,VSlider})
